import { mapActions, mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['getliveshow']),
    chgoptions: {
      get() {
        return this.getliveshow.oddItemSelect.option;
      },
      set(val) {
        this.upDate_oddItemSelect({ option: val });
      }
    },
  },
  methods: {
    ...mapActions(["upDate_oddItemSelect"]),
  }
};